import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from "reactstrap";
import { bindActionCreators } from "redux";
import { getEmployeesWithSize } from "../../../store/employee/actions";
import { toast } from "react-toastify";

class ItemModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backdrop: true,
      discount: 0,
      employeesFilter: "",
      employeesPage: 1,
      isOpen: true,
      name: "",
      pageSize: 10,
      price: 0.0,
      quantity: 1,
      selectedEmployee: null,
      selectedEmployees: [],
      selectedEmployeesFilter: "",
      selectedEmployeesIndex: 0,
      selectedEmployeesPage: 1,
      selectedRequiredEmployee: null,
      stock: 0,
      total: 0.0,
      unmountOnClose: true,
    };

    // Bind Here
    //
    this.setItem = this.setItem.bind(this);
    this.onChange = this.onChange.bind(this);
    this.addEmployee = this.addEmployee.bind(this);
    this.removeEmployee = this.removeEmployee.bind(this);
  }

  componentDidMount() {
    const { item } = this.props;
    // this.setState({
    //   name: item.name,
    //   price: item.price
    // });
    this.performGetEmployees(true);
  }

  performGetEmployees(reset = false) {
    const { employeesPage, employeesFilter, pageSize } = this.state;
    this.props.getEmployeesWithSize({
      page: employeesPage,
      employeesFilter,
      size: pageSize,
      reset
    });
  }

  componentDidUpdate(prevProps) {
    this.setItem(prevProps);
  }

  onChange(event) {
    const reg = /^(\d+\.?\d*|\.\d+)$/;
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  onAccept() {
    const {
      name,
      price,
      discount,
      total,
      quantity,
      selectedEmployees
    } = this.state;
    const tempEmp = JSON.stringify(selectedEmployees);
    const item = {
      name,
      price,
      discount,
      total,
      quantity,
      selectedEmployees: JSON.parse(tempEmp)
    };
    this.props.onAccept(item);
    this.setState({ quantity: 1, selectedEmployees: [] });
  }

  renderSelectedEmployees() {
    const { selectedEmployees } = this.state;
    if (selectedEmployees != null) {
      const result = selectedEmployees.map(item => {
        return (
          <div
            className="div-employee"
            onDoubleClick={() => this.removeEmployee(item)}
            key={item.selectedEmployeesIndex}
          >
            {item.employee.name} {item.employee.lastname}
          </div>
        );
      });
      return result;
    }
  }

  renderEmployees() {
    const { employees } = this.props;
    if (employees != null) {
      const result = employees.map(employee => {
        return (
          <div
            className="div-employee"
            onDoubleClick={() => this.addEmployee(employee)}
            key={employee.id}
          >
            {employee.name} {employee.lastname}
          </div>
        );
      });
      return (
        <div>
          {result}
          <div>
            <Button> Prev </Button>
            <Button> Next </Button>
          </div>
        </div>
      );
    }
  }

  //
  onCompleteSell() {
    const { onCompleteSell } = this.props;
    const params = {
      store_id: 1,
    }
    onCompleteSell(params, "sell");
  }
  setItem(prevProps) {
    const { item } = this.props;
    if (prevProps.item != item && item != null) {
      this.setState({
        name: item.name,
        price: item.price
      });
    }
  }

  addEmployee(employee) {
    var { quantity, selectedEmployees, selectedEmployeesIndex } = this.state;
    if (selectedEmployees.length + 1 > quantity) {
      toast.warn("Límite de empleados requeridos alcanzado.");
    } else {
      selectedEmployees.push({ selectedEmployeesIndex, employee });
      selectedEmployeesIndex++;
      this.setState({ selectedEmployees, selectedEmployeesIndex });
    }
  }

  removeEmployee(employee) {
    const { selectedEmployees } = this.state;
    const index = selectedEmployees.indexOf(employee);
    selectedEmployees.splice(index, 1);
    this.setState({ selectedEmployees });
  }

  render() {
    const {
      // total,
      backdrop,
      discount,
      name,
      price,
      quantity,
      selectedEmployees,
      stock,
      unmountOnClose,
    } = this.state;
    const { total, isOpen, onAccept, onCancel, onCompleteSell } = this.props;
    let newTotal = 0;
    if (discount != 0) {
      newTotal = quantity * ((price * discount) / 100);
    } else {
      newTotal = quantity * price;
    }

    return (
      <Modal
        isOpen={isOpen}
        className="second-step-modal modal-sm"
        backdrop={backdrop}
        unmountOnClose={unmountOnClose}
      >
        <ModalHeader>Detalle de Pago</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              Importe
              <input
                type="text"
                className="form-control"
                disabled={true}
                value={total}
              />
            </Row>
            <Row>
              <Col>
                Método de Pago
                <Row>
                  <Col>
                    <input type="radio" className="" name="paymentType" checked />
                    Efectivo
                  </Col>
                  <Col>
                    <input type="radio" className="" name="paymentType" checked />
                    Tarjeta
                  </Col>
                  <Col>
                    <input type="radio" className="" name="paymentType" checked />
                    Mixto
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              Monto Efectivo
              <input type="text" className="form-control" />
            </Row>
            <Row>
              Monto Tarjeta
              <input type="text" className="form-control" />
            </Row>
            <Row>
              Total Vuelto
              <input type="text" className="form-control" />
            </Row>
            <Row>
              <Col>
                Selección Boleta Factura
                <Row>
                  <Col>
                    <input type="radio" className="" name="type" checked />
                    Boleta
                  </Col>
                  <Col>
                    <input type="radio" className="" name="type" checked />
                    Factura
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col>
                Solo Factura
                <Row>
                  <Col>
                    RUC <input type="text" className="form-control" />
                  </Col>
                  <Col>
                    Razón Social
                    <input type="text" className="form-control" />
                  </Col>
                </Row>
                <Row>
                  Domicilio Fiscal
                  <input type="text" className="form-control" />
                </Row>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button onClick={() => this.onCompleteSell()} color="primary"> Completar </Button>
              </Col>
              <Col>
                <Button onClick={onCancel} color="primary"> Cancelar </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>Footer</ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const {
    employees,
    error,
    loading,
    pageSize,
    total
  } = state.employee.employeeList;

  return {
    employees,
    error,
    loading,
    pageSize,
    total
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getEmployeesWithSize
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemModal);



// WEBPACK FOOTER //
// ./src/components/RemoteSellComponents/SellModal/SellModal.js